import { authContext } from 'contexts/'
import { useContext, useEffect } from 'react'

function useLogin(onComplete: (error?: string) => void, username?: string, password?: string) {
  const auth = useContext(authContext)
  useEffect(() => {
    if (username && password && auth) {
      const controller = auth.login(username, password, onComplete, onComplete)
      return () => controller.abort()
    }
  }, [username, password, onComplete, auth])
}

export default useLogin
